import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import OutOfStockAnalysisReportActions from '../../Stores/OutOfStockAnalysisReport/Actions';

const { Panel } = Collapse;

class OutOfStockAnalysisReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initOutOfStockAnalysis } = this.props;

    if (curSiteFlowId > 0) {
      initOutOfStockAnalysis();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initOutOfStockAnalysis } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initOutOfStockAnalysis();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'out_of_stock_analysis' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

OutOfStockAnalysisReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initOutOfStockAnalysis: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

OutOfStockAnalysisReportScreen.defaultProps = {
  intl: {},
  match: {},

  initOutOfStockAnalysis: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initOutOfStockAnalysis: () =>
    dispatch(OutOfStockAnalysisReportActions.outOfStockAnalysisReportInitOutOfStockAnalysis())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(OutOfStockAnalysisReportScreen));
